<template>
  <div class="container clearfix">
    <div class="markdown-box">
      <markdownEditor ref="markdownView" :config="{height:200}"></markdownEditor>
    </div>
    <div class="reply-box">
      <span @click="replyClick">回复</span>
    </div>
  </div>
</template>

<script>
import markdownEditor from "@/components/common/markdownEditor";
export default {
  name: "markdownReply",
  components:{
    markdownEditor
  },
  methods:{
    replyClick: function (){
      let htmlStr = this.$refs.markdownView.getContent()
      if (htmlStr == 'undefined' || htmlStr == '' || htmlStr == undefined){
        return
      }
      this.$emit("event-release-reply", htmlStr, 'insert')
    }
  }
}
</script>

<style scoped>
.container{
  background-color: #fff;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 3px 20px;
}
.markdown-box{
  float: left;
  width: calc(100% - 80px);
}

.reply-box{
  float: left;
  width: 80px;
}
.reply-box span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: left;
  margin-left: 20px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #fff;
  background-color: #2e7eee;
}

</style>
